import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Signal,
	ViewEncapsulation,
	signal,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

interface Scope {
	loading: Signal<boolean>;
}

@Component({
	selector: 'ms-input-text',
	templateUrl: './ms-input-text.component.html',
	styleUrls: ['./ms-input-text.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsInputTextComponent implements OnInit, OnDestroy {
	@Input() formGroup: FormGroup;
	@Input() title: string;
	@Input() key: string;
	@Input() placeholder?: string;
	@Input() iconLeft: string;
	@Input() iconRight: string;
	@Input() class: string;

	scope: Scope = {
		loading: signal(true),
	};

	/**
	 * Constructor
	 */
	constructor(private _formBuilder: UntypedFormBuilder) {
		if (!this.formGroup) {
			this.key = 'name';
			this.formGroup = this._formBuilder.group({
				name: [null, []],
			});
		}
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.scope.loading = signal(false);
		if (!this.placeholder) {
			this.placeholder = this.title;
		}
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
